// import Cookies from 'js-cookie';
import { appNetworkManager } from './network-manager';

export const getDiagnosisFields = () =>
  appNetworkManager.post(
    '/get_diagnosis_field_products',
    {},
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
export const getCheckUnusedInvoices = (id: number) =>
  appNetworkManager.post(
    '/check_unused_invoices',
    { product_id: id },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
export const getCheckDiscount = (code: number) =>
  appNetworkManager.post(
    '/check_discount_code',
    { discount_code: code },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
export const getInvoiceOrigin = (invoiceId: string, refNum: string) =>
  appNetworkManager.post(
    '/invoice_origin',
    {
      invoice_id: invoiceId,
      ref_num: refNum
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
export const getProduct = (productId: string) =>
  appNetworkManager.post(
    '/get_product',
    {
      product_id: productId
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
export const getScoreAlgo = (productId: string) =>
  appNetworkManager.post(
    '/score_algo',
    {
      product_id: productId
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
export const getGraph = (productId: string, type: 'des_t' | 'score') =>
  appNetworkManager.post(
    type === 'des_t' ? '/graph' : '/score_algo',
    {
      product_id: productId
    },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
